/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'doctrine/tech_pola': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M19 13h-6v6h6v-6zm-1 5h-4v-4h4v4z"/><path pid="1" d="M4 4v24h24V4H4zm10 4h1v3h2V8h1v3h3v3h3v1h-3v2h3v1h-3v3h-3v3h-1v-3h-2v3h-1v-3h-3v-3H8v-1h3v-2H8v-1h3v-3h3V8z"/><path pid="2" d="M29 13.646V3H18.354L16 .646 13.646 3H3v10.646L.646 16 3 18.354V29h10.646L16 31.354 18.354 29H29V18.354L31.354 16 29 13.646zm-.5-.5V28.5h-25v-25h25v9.646z"/>'
  }
})
